import React from 'react';
import { connect, useSelector } from 'react-redux';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import classNames from 'classnames';

import {
  isBulkPrescriptionsEnabled,
  isCropPlanEnabled,
  isFieldLevelSeedRecsEnabled
} from '../user/selectors';
import AdvancedScriptingCard from './AdvancedScriptingCard';
import CropSelector from './CropSelector';
import ManualScriptingCard from './ManualScriptingCard';
import FieldLevelSeedRecsCard from './FieldLevelSeedRecsCard';

var baseString = 'vra-planting-script-options';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-script-type-options': true
});
export const PlantingScriptOptions = ({
  activeCropId,
  canCreateAdvancedScript,
  canCreateManualScript,
  currentCropCanAdvancedScript,
  onClickAdvancedScriptTrigger,
  onClickManualScriptTrigger,
  onSelectCrop,
  supportedCrops
}) => {
  const isBulkPrescriptions = useSelector(isBulkPrescriptionsEnabled);
  const isFieldLevelSeedRecs = useSelector(isFieldLevelSeedRecsEnabled);
  const isCropPlan = useSelector(isCropPlanEnabled);

  const canShowFieldLevelSeedRecsCard = canCreateAdvancedScript && isFieldLevelSeedRecs && !isCropPlan;

  return (
    <section className={classString}>
      <CropSelector
        activeCropId={activeCropId}
        onSelectCrop={onSelectCrop}
        supportedCrops={supportedCrops}
      />
      <section className={`${baseString}__body`}>
        {isBulkPrescriptions && <AdvancedScriptingCard
          flow="bulk"
          isBulkEnabled={isBulkPrescriptions}
          canCreateAdvancedScript={canCreateAdvancedScript}
          cardTitle={getMessage('text__fieldview-seed-scripts')}
          currentCropCanAdvancedScript={currentCropCanAdvancedScript}
        />}
        <AdvancedScriptingCard
          flow="single"
          isBulkEnabled={isBulkPrescriptions}
          canCreateAdvancedScript={canCreateAdvancedScript}
          cardTitle={getMessage('text__fieldview-seed-scripts')}
          currentCropCanAdvancedScript={currentCropCanAdvancedScript}
          onClickAdvancedScriptTrigger={onClickAdvancedScriptTrigger}
        />
        <ManualScriptingCard
          canCreateManualScript={canCreateManualScript}
          cardText={getMessage('text__create-manual-planting-script')}
          cardTitle={getMessage('title-text__manual-planting-script')}
          onClickManualScriptTrigger={onClickManualScriptTrigger}
        />
        {canShowFieldLevelSeedRecsCard && (
          <FieldLevelSeedRecsCard
            disabled={!currentCropCanAdvancedScript}
          />
        )}
      </section>
    </section>
  );
};
PlantingScriptOptions.propTypes = {
  activeCropId: propTypes.string.isRequired,
  canCreateAdvancedScript: propTypes.bool.isRequired,
  canCreateManualScript: propTypes.bool.isRequired,
  currentCropCanAdvancedScript: propTypes.bool.isRequired,
  onClickAdvancedScriptTrigger: propTypes.func.isRequired,
  onClickManualScriptTrigger: propTypes.func,
  onSelectCrop: propTypes.func.isRequired,
  supportedCrops: propTypes.array.isRequired
};

export default connect()(PlantingScriptOptions);
